import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Card } from './Card';
import { Restaurant, cantones } from '../data/mockData';
interface RestaurantCardProps {
  restaurant: Restaurant;
  onSelect: (id: string) => void;
  delay?: number;
}
export function RestaurantCard({
  restaurant,
  onSelect,
  delay = 0
}: RestaurantCardProps) {
  const canton = cantones.find(c => c.id === restaurant.cantonId);
  return <div onClick={() => onSelect(restaurant.id)} className="cursor-pointer h-full" data-id="element-257">
      <Card delay={delay} className="h-full flex flex-col overflow-hidden group" data-id="element-258">
        <div className="relative aspect-[4/3] overflow-hidden" data-id="element-259">
          <img src={restaurant.image} alt={restaurant.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-260" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-261" />
          <div className="absolute top-3 left-3 bg-brand-gold/90 backdrop-blur-sm px-3 py-1 rounded-full border border-brand-gold" data-id="element-262">
            <span className="font-body text-xs font-bold text-bg-primary capitalize" data-id="element-263">
              {restaurant.categoryId}
            </span>
          </div>
          <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-bg-primary/90 backdrop-blur-sm px-2 py-1 rounded-md border border-border" data-id="element-264">
            <StarIcon className="w-3.5 h-3.5 text-brand-gold fill-brand-gold" data-id="element-265" />
            <span className="font-body text-xs font-bold text-white" data-id="element-266">
              {restaurant.rating}
            </span>
          </div>
        </div>

        <div className="p-5 flex flex-col flex-1" data-id="element-267">
          <h3 className="font-body font-bold text-lg text-white leading-tight line-clamp-1 mb-2" data-id="element-268">
            {restaurant.name}
          </h3>

          <div className="flex items-center gap-2 text-text-secondary text-sm font-body mb-3" data-id="element-269">
            <MapPinIcon className="w-3.5 h-3.5 text-brand-orange" data-id="element-270" />
            <span data-id="element-271">{canton?.name}</span>
            <span className="text-text-muted" data-id="element-272">•</span>
            <span className="font-medium text-brand-gold" data-id="element-273">
              {restaurant.priceRange}
            </span>
          </div>

          <p className="font-body text-text-muted text-sm line-clamp-2 mb-4 flex-1" data-id="element-274">
            {restaurant.description}
          </p>

          <div className="flex flex-wrap gap-2 mt-auto" data-id="element-275">
            {restaurant.tags.slice(0, 3).map((tag, idx) => <span key={idx} className="bg-bg-secondary text-text-secondary text-xs font-body px-2 py-1 rounded-md border border-border" data-id="element-276">
                {tag}
              </span>)}
          </div>
        </div>
      </Card>
    </div>;
}